export const TRUSTPILOT_RATING_VALUE = 4.7;
export const TRUSTPILOT_RATING_COUNT = '540';
